import { StyleSheet } from "@react-pdf/renderer";

export  const overviewTemplateStyles = StyleSheet.create({
  page: {
    padding: 30,
    fontFamily: "Helvetica",
    fontSize: 10,
  },
  pageContent: {
    flex: 1,
  },
  headerSection: {
    flexDirection: "row",
  },
  headerLeft: {
    flex: 1,
    marginRight: 20,
    paddingRight: 20,
  },
  headerRight: {
    width: "40%",
  },
  logoContainer: {
    height: 80,
    alignItems: "center",
  },
  fromSection: {
    marginBottom: 20,
    padding: 10,
  },
  toSection: {
    marginBottom: 20,
    padding: 10,
  },
  sectionTitle: {
    fontFamily: "Helvetica-Bold",
  },
  companyName: {
    fontWeight: "bold",
    marginBottom: 5,
    width: "60%",
  },
  addressText: {
    width: "80%",
  },
  invoiceDetails: {
    alignItems: "flex-end",
    rowGap: 3,
    padding: 10,
  },
  invoiceTitle: {
    fontSize: 24,
    fontFamily: "Helvetica-Bold",
    marginBottom: 10,
    marginHorizontal: "auto",
    paddingBottom: 10,
  },
  invoiceNumber: {
    fontWeight: "bold",
  },
  serviceSection: {
    marginBottom: 20,
    border: "1pt solid #000",
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#f5f5f5",
    padding: 8,
    borderBottom: "1pt solid #000",
  },
  tableHeaderCell: {
    flex: 3,
    fontFamily: "Helvetica-Bold",
    paddingHorizontal: 5,
  },
  tableHeaderCellSmall: {
    flex: 1,
    fontFamily: "Helvetica-Bold",
    textAlign: "right",
    paddingHorizontal: 5,
  },
  tableRow: {
    flexDirection: "row",
    padding: 8,
    borderBottom: "1pt solid #eee",
  },
  tableCell: {
    flex: 3,
    paddingHorizontal: 5,
  },
  tableCellSmall: {
    flex: 1,
    textAlign: "right",
    paddingHorizontal: 5,
  },
  notesSection: {
    marginBottom: 20,
    marginTop: 20,
    padding: 10,
    border: "1pt solid #ccc",
  },
  notesTitle: {
    fontFamily: "Helvetica-Bold",
    marginBottom: 5,
    paddingBottom: 5,
    borderBottom: "1pt solid #eee",
  },
  notesText: {
    fontSize: 9,
    marginTop: 5,
  },
  summarySection: {
    alignSelf: "flex-end",
    width: "40%",
    border: "1pt solid #000",
    marginTop: 10,
  },
  summaryRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 5,
    paddingVertical: 3,
    paddingHorizontal: 10,
  },
  summaryRowData: {
    flexDirection: "row",
    justifyContent: "space-between",
    gap: "10px",
    marginBottom: "2px",
  },
  summaryLabel: {
    fontFamily: "Helvetica-Bold",
    marginRight:"10px",
    width:"35%"
  },
  summaryLabel1: {
    fontFamily: "Helvetica-Bold",
    marginRight:"10px",
    width:"80%"
  },
  sumaryTax2: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 5,
    paddingVertical: 4,
    paddingHorizontal: 10,
    borderBottom: "1pt solid #000",
  },
  summaryAmount: {
    width: "70%",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 5,
  },
  signatureSection: {
    flexDirection: "row",
    justifyContent: "flex-end",
    position: "absolute",
    bottom: 0,
    right: 0,
    padding: "20px",
  },
  signatureTitle: {
    fontFamily: "Helvetica-Bold",
    borderBottom: "1pt solid #eee",
  },
});